<template>
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-md-6 col-sm container">
                <div class="row mt-3">
                    <div class="col h-3">ログアウトしました。</div>
                </div>
                <div class="row mt-3">
                    <div class="col message">{{ logoutMessage }}</div>
                </div>
                <div class="row mt-3">
                    <div class="col message text-start">
                        <a href="#"
                           @click.prevent.stop="onClickLink"
                           class="link">{{ sec }}秒でログイン画面に移動します{{ dots }}</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import {defineComponent, onMounted, onUnmounted, ref} from "vue";
import {useRoute, useRouter} from "vue-router";
import {findLogoutMessageByKey, subPaths} from "@/utils/consts";
import {loadingOverlayStateStore} from "@/stores/loading-overlay-state-store";

export default defineComponent({
    name: "LoggedOut",
    setup() {
        const logoutMessage = ref<string>(""),
            dots = ref<string>(""),
            sec = ref<number>(0)
        const route = useRoute(),
            router = useRouter()

        let intervalId = 0

        const startTransitionTimer = () => {
            sec.value = 5
            intervalId = window.setInterval(() => {
                sec.value--
                dots.value += "."
                if (sec.value <= 0) {
                    window.clearInterval(intervalId)
                    router.push(subPaths.LOGIN)
                }
            }, 1000)
        }

        const onClickLink = () => {
            window.clearInterval(intervalId)
            router.push(subPaths.LOGIN)
        }

        onMounted(() => {
            const logoutParam = route.query.logout_message as string
            console.log('logout param', logoutParam)
            if (logoutParam) {
                logoutMessage.value = findLogoutMessageByKey(logoutParam)
            } else {
                logoutMessage.value = ""
            }
            startTransitionTimer()
            loadingOverlayStateStore.commit("fadeout")
        })

        onUnmounted(() => {
            window.clearInterval(intervalId)
        })

        return {
            logoutMessage,
            dots,
            sec,
            onClickLink,
        }
    }
})
</script>

<style scoped lang="scss">
.message {
//font-size: 15px;

.link {
    display: block;
    width: 100%;
    text-align: start;
    text-indent: 10vw;
}
}
</style>